import _ from 'lodash';
import getInit from '@cores/apis/others_api/core_basic';
export default function getCommonInit() {
    return getInit().then(res => {
        const data = {
            globalConfig: _.get(res, 'data'),
        };
        return data;
    });
}
